import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import useInstructionsPopUp from '../../hooks/useInstructionsPopUp';
import { Form, Header } from './PopUp.styled';

export default function InstructionsPopUp({ setShow, handleSubmit }) {
	const hook = useInstructionsPopUp({ handleSubmit });

	return (
		<>
			{hook.isLoading && <Loading />}
			<PopUp setShow={setShow}>
				<Header>Send instructions</Header>
				<Form onSubmit={hook.onSubmit}>
					<SelectInput
						options={hook.fileOptions}
						color={Colors.darkBlue}
						name='Instructions docs'
						setSelected={(value) => hook.setSelectedFileNames(value)}
						selected={hook.selectedFileNames}
						type='number'
						width={200}
						multiple
					/>
					<Input
						name='Contract date'
						width={100}
						color={Colors.darkBlue}
						inputRef={hook.dateRef}
						type='date'
						inputWidth={160}
						required
					/>
					<SubmitButton text='Send email' color={Colors.darkBlue} />
				</Form>
			</PopUp>
		</>
	);
}
